import { faPause, faPlay, faTrash } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as React from 'react';
import { useState } from 'react';
import VoxelIconButton from '../../../../components/voxel/Buttons/VoxelIconButton';
import VoxelDataTableCell from '../../../../components/voxel/DataTable/VoxelDataTableCell';
import VoxelDataTableRow from '../../../../components/voxel/DataTable/VoxelDataTableRow';
import { GoogleAdsRequestAnalysisGq } from '../../../../graphql/projects/models/GoogleAdsRequestAnalysisGq';
import { UpdateGoogleAdsRequestCommandGq } from '../../../../graphql/projects/mutations/googleAds/useUpdateGoogleAdsRequestGq';
import { projectsApiService } from '../../../../graphql/projects/projectsApiService';
import { SearchRequestTypes } from '../../../../components/muiLegacy/Tables/KeywordTable/ToolbarButtons/AddKeywords/AddBasicKeywords/logic/SearchModels';
import ProjectStatusKeywordRequestChip from './ProjectStatusKeywordRequestChip';
import { usePopoverContext } from '../../../../components/voxel/Popover/PopoverLogic';

export interface ProjectStatusKeywordRequestRowProps {
  requestAnalysis: GoogleAdsRequestAnalysisGq;
  isCombo: boolean;
  setDeleteRequestId: React.Dispatch<React.SetStateAction<number>>;
  index?: number
}

const ProjectStatusKeywordRequestRow: React.FC<ProjectStatusKeywordRequestRowProps> = ({
  requestAnalysis,
  isCombo,
  setDeleteRequestId,
  index
}) => {
  const done = requestAnalysis.totalCalls === requestAnalysis.completedCalls;

  // Common API error
  const [mutating, setMutating] = useState(false);

  // Control functionality
  const controlMutation = projectsApiService.mutations.googleAds.useUpdateGoogleAdsRequest();
  const createActionFunction =
    (command: Partial<UpdateGoogleAdsRequestCommandGq>) => (event?: React.MouseEvent<any>) => {
      event.stopPropagation();
      setMutating(true);
      controlMutation({
        requestId: requestAnalysis.request.id,
        projectId: requestAnalysis.request.parentProjectId,
        ...command,
      }).finally(() => setMutating(false));
    };

  const popoverContext = usePopoverContext();

  return (
    <>
      <VoxelDataTableRow key={requestAnalysis.request.id}>
        <VoxelDataTableCell className={`overflow-hidden text-ellipsis ${index === 0 ? 'border-t-0' : ''}`}>
          {requestAnalysis.request.name}
        </VoxelDataTableCell>
        <VoxelDataTableCell className={index === 0 ? 'border-t-0' : ''}>
          <div className="flex flex-row items-center gap-2">
            <ProjectStatusKeywordRequestChip requestAnalysis={requestAnalysis} />
          </div>
        </VoxelDataTableCell>
        <VoxelDataTableCell
          align="right"
          className={`flex flex-row gap-1 items-center justify-end flex-nowrap ${index === 0 ? 'border-t-0' : ''}`}
        >
          {!done && (
            <VoxelIconButton
              tooltip="Pause"
              containerType="table"
              icon={<FontAwesomeIcon icon={faPause} size="1x" />}
              size="xs"
              color="white"
              onClick={createActionFunction({ paused: true })}
              disabled={mutating || requestAnalysis.request.paused || !requestAnalysis.queuedCalls}
            />
          )}
          {!done && (
            <VoxelIconButton
              tooltip="Resume"
              containerType="table"
              size="xs"
              color="white"
              onClick={createActionFunction({ paused: false })}
              disabled={mutating || !requestAnalysis.request.paused || !requestAnalysis.queuedCalls}
              icon={<FontAwesomeIcon icon={faPlay} size="1x" />}
            />
          )}
          <VoxelIconButton
            tooltip={'Delete'}
            containerType="table"
            size="xs"
            color="white"
            onClick={() => {
              setDeleteRequestId(requestAnalysis.request.id);
              popoverContext.setOpen(false);
            }}
            disabled={mutating || requestAnalysis.request.duplicateCheck}
            icon={<FontAwesomeIcon icon={faTrash} size="1x" />}
          />
        </VoxelDataTableCell>
      </VoxelDataTableRow>
    </>
  );
};

export default ProjectStatusKeywordRequestRow;
